// extracted by mini-css-extract-plugin
export default {"link":"link-social_link__vVSdT"};